export const table = `title: Efficacy of Common Antibiotics Against Resistant Infections

---
columnTitle: Antibiotic class
columnTitle: Susceptible (%)
columnTitle: MRSA (%)
columnTitle: ESBL E. coli (%)
columnTitle: CRE (%)
---
**Penicillins**
95
<5
10-20
<5
---
**Cephalosporins (3rd gen)**
90
<5
20-40
<5
---
**Carbapenems**
>99
70-80
>95
30-60
---
**Fluoroquinolones**
85
40-50
30-50
15-30
---
**Aminoglycosides**
90
60-70
60-80
40-60
---
**Vancomycin**
>99 (gram+)
>95
N/A
N/A
-->

Source: CDC Antibiotic Resistance Threats Report, 2022; WHO GLASS database. MRSA = methicillin-resistant S. aureus; ESBL = extended-spectrum beta-lactamase; CRE = carbapenem-resistant Enterobacterales. Ranges reflect geographic variation.
`;